module.exports = __webpack_public_path__ + "img/bg0602.2d9548d0.gif";